import { getClient } from '@chegg-web-tools/apollo-utils';
var apolloClientInstance;

/**
 * Creates and configures the ApolloClient with default context
 */
function createApolloClient() {
  var client = getClient();
  return client;
}

/**
 * Always creates a new apollo client on the server
 * Creates or reuses apollo client in the browser.
 */
export function initApolloClient() {
  // Make sure to create a new client for every server-side request so that data
  // isn't shared between connections (which would be bad)
  if (typeof window === 'undefined') {
    return createApolloClient();
  }

  // Reuse client on the client-side
  if (!apolloClientInstance) {
    apolloClientInstance = createApolloClient();
  }
  return apolloClientInstance;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/apollo/client.js
// module id = 669
// module chunks = 11